import { LegacyRef, ReactNode, forwardRef } from 'react';
import cx from 'classnames/bind';

import styles from './Button.module.scss';

interface ButtonProps {
  children: string | ReactNode;
  handleClick?: () => void;
  className?: string;
  disabled?: boolean;
}

const cn = cx.bind(styles);

const Button = forwardRef(
  (
    { children, handleClick, className, disabled = false }: ButtonProps,
    ref: LegacyRef<HTMLButtonElement>,
  ) =>
    ref ? (
      <button
        disabled={disabled}
        ref={ref}
        type="button"
        className={cn('button', className)}
      >
        {children}
      </button>
    ) : (
      <button
        disabled={disabled}
        onClick={handleClick}
        type="button"
        className={cn('button', className)}
      >
        {children}
      </button>
    ),
);

export default Button;
